import React, { useEffect } from 'react';
import Presentation from './../molecules/Pagecontact/Presentation.jsx';
import Linkedin from './../atoms/PageContact/Linkedin.jsx';
import Video from './../atoms/PageContact/Video.jsx'
import SharePortfolio from '../molecules/InputBlog/SharePortfolio.jsx';
import GoUp from '../scripts/GoUp.js';

const PageContact = () => {

    useEffect(() => {
        GoUp()
    }, [])

    return(
        <main class="main">

        < Presentation />
        < SharePortfolio />
        < Linkedin LinkIcon="https://raw.githubusercontent.com/eliud-cesar/Portfolio-Data-Base/21c05bc7a6774148af276dbfe23ed4f9d351c7d1/images/social-media/linkedin-icon.svg" />
        < Video LinkVideo="https://www.youtube.com/embed/b4bFUWJMcFs" />

        </main>
    )
}

export default PageContact;
